import { Button, ClearableInput, Select } from "@rio-cloud/rio-uikit";

interface Props {
    total: number;
    onChange: (str: number) => void;
    totalCheckpoints?: number;
    onClick?: () => void;
    disabled?: boolean;
    weightType?: InputTypeWeight[];
    handleWeightType: (item?: InputTypeWeight) => void;
}

export const OptionsWeightType: InputTypeWeight[] = [
    { id: '1', label: 'Kg' },
    { id: '2', label: 'M³' },
    { id: '3', label: 'Unidade' },
]

export interface InputTypeWeight {
    id: string;
    label: string;
}

const MilkRun = ({ total, onChange, totalCheckpoints, onClick, disabled, weightType, handleWeightType }: Props) => {
    const widthPercentage = total && totalCheckpoints
        ? (parseFloat(totalCheckpoints?.toString()) / total) * 100
        : 0;

    return (
        <div className="display-flex flex-column gap-15">
            <div>
                <span>Capacidade de carregamento utilizada ({totalCheckpoints || '-'}/{total || '-'})</span>
                <div className="progress">
                    <div
                        className={`progress-bar progress-bar-animated ${widthPercentage > 100 ? 'progress-bar-danger' : 'progress-bar-primary'}`}
                        style={{
                            width: `${widthPercentage}%`
                        }}>
                    </div>
                </div>
            </div>
            <form>
                <fieldset className="display-flex flex-row gap-10 align-items-end">
                    <div className="flex-1-1">
                        <label>Capacidade (Unidades)</label>
                        <ClearableInput
                            inputClassName="rounded-small"
                            maxLength={10}
                            value={total?.toString()}
                            onChange={(value) => {
                                const numericValue = value.replace(/\D/g, '');
                                onChange(Number(numericValue))
                            }}
                        />

                    </div>
                    <div className="flex-1-2 min-width-100">
                        <label>Tipo de capacidade</label>
                        <Select
                            id='1'
                            placeholder=''
                            options={OptionsWeightType}
                            onChange={handleWeightType}
                            value={[weightType?.[0]?.id ?? '1']}
                            className='bg-always-black'
                            btnClassName='rounded-small'
                            dropdownClassName=''
                        />
                    </div>
                    <div>
                        <Button onClick={onClick} disabled={disabled}>Calcular rota com MilkRun</Button>
                    </div>
                </fieldset>
            </form>
        </div>
    )
}

export default MilkRun